import React from 'react';
import accessibleSvg from 'utils/accessibleSvg';

export default accessibleSvg(({ children, ...props }) => (
  <svg fill="currentColor" viewBox="0 0 512.00079 448" {...props}>
    {children}
    <path d="M304.00077 384h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V16a16 16 0 0 0-16-16H80.000772a16 16 0 0 0-16 16v304h-48c-14.1900004 0-21.3700004 17.24-11.2900004 27.31l80.0000004 96a16 16 0 0 0 22.619998 0l80-96c10.02-10.05 2.89-27.31-11.33-27.31zm256-192h-192a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128h-128a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm128-256h-256a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16z" />
  </svg>
));
